/**
 * Loyalty tab -- phase 6b, Task 5. Spec §0: the earning threshold/points
 * config AND the five tier bands with their reward values live on ONE
 * screen, so an admin changing "when do customers earn" sees "what do they
 * get" right below it. Writes are gated on `useCanWriteDiscounts()`; every
 * other role gets the same forms read-only with no Save.
 */
import React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import { useCanWriteDiscounts } from '../roles';
import { ConfigForm } from './ConfigForm';
import { TierBandsEditor } from './TierBandsEditor';
import { CardColoursEditor } from './CardColoursEditor';

export const LoyaltyScreen: React.FC = () => {
  const readOnly = !useCanWriteDiscounts();

  return (
    <Stack spacing={3} data-testid="loyalty-screen">
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Earning rules
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            When customers earn points and how many points a reward costs. Changes apply to the next paid order.
          </Typography>
          <ConfigForm readOnly={readOnly} />
        </CardContent>
      </Card>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Tier bands
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Lifetime-spend bands and the reward value each one issues. All five are saved together.
          </Typography>
          <TierBandsEditor readOnly={readOnly} />
        </CardContent>
      </Card>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Loyalty card colours
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            The colour of the progress bar on the customer's DeeReward card in the app, by how many 10-point cycles they have earned. Colours only: rewards come from the tier bands above.
          </Typography>
          <CardColoursEditor readOnly={readOnly} />
        </CardContent>
      </Card>
    </Stack>
  );
};

export default LoyaltyScreen;
